module.exports = new __parcel__URL__("sprite.f0725d09.svg").toString();